var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6364 14.0909V12.6364C11.6364 11.0297 10.3339 9.72729 8.72727 9.72729H2.90909C1.30244 9.72729 0 11.0297 0 12.6364V14.0909",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6363 12.6364V14.0909H15.6364V12.6364C15.6364 11.0297 14.3339 9.72729 12.7273 9.72729H10.7272C12.3338 9.72729 13.6363 11.0297 13.6363 12.6364Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81827 6.81818C7.42492 6.81818 8.72736 5.51574 8.72736 3.90909C8.72736 2.30244 7.42492 1 5.81827 1C4.21162 1 2.90918 2.30244 2.90918 3.90909C2.90918 5.51574 4.21162 6.81818 5.81827 6.81818Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90906 6.64173C9.22089 6.75588 9.55772 6.81818 9.9091 6.81818C11.5157 6.81818 12.8182 5.51574 12.8182 3.90909C12.8182 2.30244 11.5157 1 9.9091 1C9.55772 1 9.22089 1.0623 8.90906 1.17645C10.0231 1.58425 10.8181 2.65382 10.8181 3.90909C10.8181 5.16436 10.0231 6.23393 8.90906 6.64173Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.fed07f29.svg";
export { ForwardRef as ReactComponent };